import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-risk-diagnosis',
  templateUrl: './risk-diagnosis.component.html',
  styleUrls: ['./risk-diagnosis.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RiskDiagnosisComponent implements OnInit {
  pageIndex = 0;
  tabIndex = 0;
  answers: any = [];
  loading = false;

  color = 'primary';
  mode = 'indeterminate';
  value = 50;

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
  }

  start(): void {
    this.pageIndex = 1;
  }

  answerQuestion(value) {
    this.answers.push({
      question_id: this.tabIndex + 1,
      answer: value
    });
    this.tabIndex++;

    if (this.tabIndex === 4) {
        this.save();
    }
  }

  save() {
    this.loading = true;
    this.dataService.pollExpress(this.answers).subscribe(data => {
      this.loading = false;
      this.pageIndex = 2;
    }, error => {
      console.log(error);
      this.loading = false;
      this.pageIndex = 2;
    });
  }
}
